$(".product-color-swatch").on("click", function() {

  let wrapper = $(event.target)[0].closest(".card-wrapper")
  image = $(wrapper).find("img")[0]
  link = $(wrapper).find(".card__heading.h5 .full-unstyled-link")[0]

  console.log(link)

  let variantImage = this.dataset.variantImage
  let variantLink = this.dataset.variantLink

  if (!variantImage.includes("no-image")) {
    image.src = variantImage
    image.srcset = variantImage
  }

  if (variantLink != "" ) {
    link.href = variantLink
  }
    
  console.log(image)
  console.log(this)
  
  event.preventDefault()
  console.log("hello")
})

let open = false

$("#Details-menu-drawer-container").on("click", function() {

  if(window.location.pathname == "/") {

    if(!open) {
      $("header.header")[0].style.cssText = 'background:#292656 !important';
      open = true
    } else {
      $("header.header")[0].style.cssText = 'background:transparent !important';
      open = false
    }
  }
})